export const insuranceStageDropdown = [
  "Insurance Endorsement",
  "Zero Depreciation Insurance New Policy",
  "Comprehensive Insurance New Policy",
  "Third Party Insurance New Policy",
];

export const insuranceStatusDropdown0 = [
  "Vehicle Sale – First RTO Work (Transfer Ownership) Done.",
  "Required New Owner Name RC or Particular & old Insurance copy.",
  "Required RTO TTO Form 28, 29, 30.",
  "Required delivery note & Company stamp.",
  "New Customer KYC (Aadhar Card, Pan)",
  "New Customer Mail ID & Mobile Number.",
  "All documents submit to Insurance Company.",
  "Vehicle Inspection (Compulsory)",
  "NCB Amount (Depend on old policy)",
  "NCB Amount payment (Depend on old policy)",
  "Insurance Endorsement done.",
];

export const insuranceStatusDropdown1 = [
  "Vehicle age required 5 Years Old.",
  "Vehicle RC or Particular.",
  "Add one required as per customer.",
  "Sending quotation to customer.",
  "Customer confirmation.",
  "Vehicle inspection.",
  "Customer KYC (Aadhar Card, Pan).",
  "Customer Mail ID & Mobile Number.",
  "Payment Mode (Cash, Cheque, Online).",
  "Zero Depreciation Insurance Policy done.",
];

export const insuranceStatusDropdown2 = [
  "Vehicle RC or Particular.",
  "Add one required as per customer.",
  "Sending quotation to customer.",
  "Customer confirmation.",
  "Vehicle inspection.",
  "Customer KYC (Aadhar Card, Pan).",
  "Customer Mail ID & Mobile Number.",
  "Payment Mode (Cash, Cheque, Online).",
  "Comprehensive Insurance Policy done.",
];

export const insuranceStatusDropdown3 = [
  "Vehicle RC or Particular.",
  "Sending quotation to customer.",
  "Customer confirmation.",
  "Customer KYC (Aadhar Card, Pan).",
  "Customer Mail ID & Mobile Number.",
  "Payment Mode (Cash, Cheque, Online).",
  "Third Party Insurance Policy done.",
];
